export default "/images/arrow-left.svg?3aa195f965672df5f96d1bf70d4c801e";